<div class="payment-shimmer-wraper comman-wrap">
  <ng-container>
  </ng-container>
  <ng-container>
  </ng-container>
  <section class="green-panel">
      <div class="container">
          <div class="row">
              <div class="col-12 text-center" *ngIf="paymentProcess">
                <div class="spinner-border text-light" role="status">
                  <span class="sr-only"></span>
                </div>
                <p>Please wait while we process your payment.</p>
              </div>
              <div class="col-12 text-center" *ngIf="!paymentProcess">
                <p>&nbsp;</p>
              <br>
                </div>
          </div>
      </div>
  </section>
  <section class="track-bar">
      <div class="container">
          <div class="row justify-content-center">
              <div class="col-12 track-card">
                  <div class="shimmer-wrap">
                      <div class="wrapper">
                          <div class="comment-second br animate w-30"></div>
                          <div class="comment-track br animate w-100"></div>
                          <div class="comment-track br animate w-20"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
  <section class="full-card">
      <div class="container">
          <div class="row">
              <div class="col-12">
                  <div class="shimmer-wrap">
                      <div class="wrapper">
                          <div class="card-full-length br animate w-100"></div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-12">
                  <div class="shimmer-wrap mt-4">
                      <div class="wrapper">
                          <div class="comment-second br animate w-30"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
  <section class="white-card">
      <div class="container">
          <div class="row">
              <div class="col-12 white-bg">
                  <div class="shimmer-wrap">
                      <div class="wrapper">
                          <div class="comment br animate w-20"></div>
                          <div class="comment br animate w-30"></div>
                          <div class="comment br animate w-10"></div>
                          <div class="shimmer-button br animate w-10"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
 </div>
